module.exports = require("/opt/build/repo/gatsby/gatsby-browser.ts");